import reduxCreator from '../libs/mk-womanizer/redux-creator';
import axiosPlugin from "../libs/mk-womanizer/ac-axios-plugin";


// function socketPlugin(reduxCreator) {
//     let subscribe = reduxCreator.action('SUBSCRIBE', (subscribeTo)=>{
//         socketClient.subscribe(subscribeTo);
//         return {};
//     });
//     reduxCreator.registerAction('subscribe', subscribe);
//     reduxCreator.reducerForType('SUBSCRIBE', (state) => ({...state, subscribed:true}));
// }

let redux = reduxCreator.type('CURRENT_USER').plugin(axiosPlugin);
//

export const TYPES = redux.types;

let fetchCurrentUserAction = redux.fetchActionGetOne();

let updateCurrentUserAction = redux.fetchActionUpdate();

let deleteCurrentUserAction = redux.fetchActionDelete();

redux.reducerForType('UPDATE_AVATAR', (state,payload) => {
    let newState = {...state};
    if(payload.data && payload.data.uri){
        newState = {
            ...newState,
            data : { ...newState.data,
                profile : { ...newState.data.profile,
                    avatar : payload.data.uri
                }
            }
        }
    }
    return newState;
});

redux.reducerForType('UPDATE_COVER', (state,payload) => {
    let newState = {...state};
    if(payload.data && payload.data.uri){
        newState = {
            ...newState,
            data : { ...newState.data,
                profile : { ...newState.data.profile,
                    cover : payload.data.uri
                }
            }
        }
    }
    return newState;
});

redux.reducerForType('UPDATE_SUCCESS', (state,payload) => {
    let newState = {...state};
    if(payload && payload.payload){
        newState = {
            ...newState,
            loading : false,
            submitting : false,
            data : { ...newState.data,
                ...payload.payload
            }
        }
    }
    return newState;
});

redux.reducerForType('UPDATE_CONFIRME_MAIL', (state,payload) => {
    let newState = {...state};
    if(payload.data && payload.data.token){
        newState = {
            ...newState,
            data : { ...newState.data,
                email : { ...newState.data.email,
                    newMail : ""
                }
            }
        }
    }
    return newState;
});

export const fetchCurrentUser = () => fetchCurrentUserAction(`/users/me`);
export const updateCurrentUser = (data) => updateCurrentUserAction(`/users/me`, data);
export const updateCurrentUserNotification = (data) => updateCurrentUserAction(`/users/me/update-notifications`, data);
export const updateCurrentUserRightModerationTag = () => updateCurrentUserAction(`/users/me/update-right-moderation-tag`);

export const deleteCurrentUser = () => deleteCurrentUserAction(`/users/me/confirm-suppression`);

export const resetCurrentUser = () => redux.actions.reset();

export const currentUser = redux.reducer();